
import QuickPractitioner from 'components/QuickPractitioner/QuickPractitioner'
import React, { useEffect, useState } from 'react'
import doctor_kit_icon from "assets/svgIcon/doctor-kit-icon.svg";
import star_fill from "assets/svgIcon/star-fill.svg";
import hos_bg from "assets/images/hos-bg-2.png";
import { InstitutionServices } from 'utils/InstitutionServices';
import { useSelector } from 'react-redux';
import { PatientService } from 'utils/PatientService';
import { FAILED_TO_FETCH_DATA } from 'utils/Constants';
import { showErrorMessage } from 'common/AlertContainer';
import { isPatient } from 'utils/UserHelper';
import { getFullAddressWithLocationCityAndState } from 'utils/Utils';
import CommonLoader from 'common/CommonLoader';

export default function NearbyHospitals() {
    const [institutions, setInstitutions] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const currentUser = useSelector((state) => state.auth.currentUser);

    const getInstitutionsProfilesOnTheBasisOfPatientLocation = (id) => {
        PatientService.getPatientById(id)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    InstitutionServices.searchInstitutions(`cy==*${encodeURIComponent(data?.address?.city)}*`, 0, 4)
                        .then((response) => {
                            const { status, data } = response;
                            if (status === 200) {
                                console.log(data);
                                const { currentPage, totalPages, contents } = data;
                                setIsLoading(false);
                                setInstitutions((prevInstitutions) => [...prevInstitutions, ...contents]);
                                setHasMore(totalPages - currentPage !== 1);
                            } else {
                                setIsLoading(false);
                                showErrorMessage(FAILED_TO_FETCH_DATA);
                            }
                        })
                }
            })
    }

    useEffect(() => {
        console.log(currentUser);
        if (isPatient()) {
            getInstitutionsProfilesOnTheBasisOfPatientLocation(currentUser?.profileId);
        }
    }, [currentUser])

    return (
        <div className='nex-quick-hospital-card'>
            <h3 className='nex-text-xl nex-card-title nex-color-dark-blue'>Nearby hospitals</h3>
            {
                isLoading ?
                    <div className="text-center">
                        <CommonLoader />
                    </div>
                    :
                    <div className="nex-quick-hospital-columns">
                        {institutions.map((institution) => (
                            <div className="nex-quick-hospital-item">
                                {institution?.bannerId ?
                                    <div className="graphic">
                                        <img
                                            style={{ width: "100%", borderRadius: "inherit" }}
                                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${institution?.guid}/${institution?.bannerId}`} />
                                    </div>
                                    :
                                    <div className="graphic" style={{ backgroundImage: 'url(' + hos_bg + ')' }}></div>
                                }
                                <div className="info">
                                    <div className="nex-flex">
                                        <div className="profile-info">
                                            <QuickPractitioner
                                                name={institution?.name}
                                                isTitleLink={true}
                                                titleLink={`/institution/${institution?.profileId}`}
                                                address={getFullAddressWithLocationCityAndState({ location: institution?.location ?? "", city: institution?.city ?? "", state: institution?.state ?? "" })}
                                            />
                                        </div>
                                        <div className="profile-extra-links">
                                            <a href=""><span className='icon'><img src={doctor_kit_icon} alt="" /></span> 150+ Doctors</a>
                                        </div>
                                    </div>
                                    <div className="nex-review">
                                        <div className="star">
                                            <span className='icon'><img src={star_fill} alt="" /></span>
                                            <span className='icon'><img src={star_fill} alt="" /></span>
                                            <span className='icon'><img src={star_fill} alt="" /></span>
                                            <span className='icon'><img src={star_fill} alt="" /></span>
                                            <span className='icon'><img src={star_fill} alt="" /></span>
                                        </div><div className="ratings"><a href="">1345 Reviews</a></div>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
            }
        </div>
    )
}
